// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"39529812","312":"3ce985fa","376":"535b9bdc","455":"11b6f409","950":"66496652","977":"faaa31a4"}[chunkId] + ".chunk.js";
};